// Phase 6.2a — Warranty Renewal Campaigns data-testid registry.
export const CAMP = {
  navCampaigns: "nav-campaigns",

  // List page
  page: "campaigns-page",
  createBtn: "campaign-create-btn",
  searchInput: "campaign-search-input",
  statusFilter: "campaign-status-filter",
  refreshBtn: "campaigns-refresh-btn",
  listTable: "campaigns-table",
  listRow: (id) => `campaign-row-${id}`,
  pagePrev: "campaigns-page-prev",
  pageNext: "campaigns-page-next",

  // Create modal
  modalOpen: "campaign-modal",
  modalName: "campaign-form-name",
  modalDescription: "campaign-form-description",
  modalWindow: "campaign-form-expiry-window",
  modalAttempts: "campaign-form-max-attempts",
  modalRetryHours: "campaign-form-retry-hours",
  modalCustomerType: "campaign-form-customer-type",
  modalMinValue: "campaign-form-min-value",
  modalMaxValue: "campaign-form-max-value",
  modalExcludeRenewed: "campaign-form-exclude-renewed",
  modalSubmit: "campaign-form-submit",
  modalCancel: "campaign-form-cancel",

  // Detail page
  detailPage: "campaign-detail-page",
  detailName: "campaign-detail-name",
  detailStatus: "campaign-detail-status",
  detailStart: "campaign-detail-start-btn",
  detailPause: "campaign-detail-pause-btn",
  detailResume: "campaign-detail-resume-btn",
  detailStop: "campaign-detail-stop-btn",
  detailPreview: "campaign-detail-preview-btn",
  detailEnroll: "campaign-detail-enroll-btn",
  detailProcessRetries: "campaign-detail-retries-btn",

  // Filters editor
  editFilters: "campaign-edit-filters-btn",
  saveFilters: "campaign-save-filters-btn",

  // Report
  reportTotal: "campaign-report-total",
  reportQueued: "campaign-report-queued",
  reportRenewed: "campaign-report-renewed",
  reportEscalated: "campaign-report-escalated",
  reportRevenue: "campaign-report-revenue",
  reportPotential: "campaign-report-potential-revenue",

  // Leads
  leadsTable: "campaign-leads-table",
  leadsRow: (id) => `campaign-lead-row-${id}`,
  leadsSearch: "campaign-leads-mobile-search",
  leadsStatusFilter: "campaign-leads-status-filter",
  leadsPagePrev: "campaign-leads-page-prev",
  leadsPageNext: "campaign-leads-page-next",
  leadGeneratePaymentLink: (id) => `campaign-lead-plink-${id}`,
  leadPaymentLinkAnchor: (id) => `campaign-lead-plink-url-${id}`,
};
